class InitResult {
	private _data: any;
	private _lines: [number];

	constructor(data: any) {
		this._data = data;
		this._lines = [1];
	}

	getData() {
		return this._data;
	}

	getLastRound() {
		if (!this._data.last_round) {
			return;
		}

		let data = {
			roundId: this._data.last_round.round_id,
			ended: this._data.last_round.ended ? true : false,
			linesCount: this._data.last_round.lines_cnt,
			atomicBet: this._data.last_round.atomic_bet,
			coin: this._data.last_round.coin,
			credit: undefined,
		};

		if (this._data.last_round.result) {
			data.credit = this._data.last_round.result.credit;
		}

		return data;
	}

	getFreeSpinsProgress() {
		return this._data.free_spin;
	}

	getMathVersion() {
		try {
			return this._data.logic.MATHVersion || 0;
		} catch (e) {
			return null;
		}
	}

	/**
	 * @return {boolean}
	 */
	isForcestopEnabled() {
		if (this._data.behavior.reel.spin.enableForceStop == null) {
			return true;
		}

		return !!this._data.behavior.reel.spin.enableForceStop;
	}

	getFailResult() {
		return this._data.logic.failResult;
	}

	getLegislation() {
		return this._data.legislation;
	}

	getWebSocket() {
		return this._data.web_socket;
	}

	getGameSpecifics() {
		return this._data.logic.gameSpecifics;
	}
	getFSGameSpecifics(): any {
		return this._data.logic.fsGameSpecifics;
	}
	getFSTotalWin(){
		return this._data.fs_total_win
	}

	getLinesCount() {
		return this._data.lines_cnt;
	}

	setLines(count: number): void {
		for (let i = 0; i < count; i++) {
			this._lines[i] = i + 1;
		}
	}

	setLinesArray(lines: [number]) {
		this._lines = lines;
	}

	getLines() {
		return this._lines;
	}

	getBalance() {
		return this._data.balance;
	}

	getCurrency(): string {
		return (this._data.currency + "").toUpperCase();
	}

	getCoins(): Array<number> {
		return this._data.logic.coins;
	}

	getCoin(): number {
		return this._data.coin;
	}

	getDecimalPlaces() {
		return this._data.decimal_places;
	}

	getBetSet() {
		return this._data.logic.bet_set;
	}

	getSymbolDefinition() {
		return this._data.logic.symbols;
	}

	getStartMatrix() {
		return this._data.matrix.reelMatrix;
	}

	getStartSymbolsPosition() {
		return this._data.matrix.position;
	}

	getReels() {
		return this._data.logic.reels;
	}

	getWinLines() {
		return this._data.logic.winLines;
	}

	getSessionId() {
		return this._data.session_id;
	}

	getMinBigWinFactor() {
		return this._data.behavior.reel.minBigWinFactor;
	}

	getMinMegaWinFactor() {
		return this._data.behavior.reel.minMegaWinFactor;
	}

	getMinSuperMegaWinFactor() {
		return this._data.behavior.reel.minSuperMegaWinFactor;
	}

	getPlayerId() {
		return this._data.player_id;
	}

	getSoundBehavConfig() {
		return this._data.behavior.sound;
	}

	getBehavior() {
		return this._data.behavior;
	}

	getBonus() {
		return this._data.bonus;
	}
}

export default InitResult;
